<app-menu></app-menu>
<div class="container d-flex justify-content-center">
  <div class="card">
    <div class="card-header">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" routerLink="/login">Iniciar Sesión</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" routerLink="/registro">Crear Cuenta</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <form #f="ngForm" (ngSubmit)="onRegister()" novalidate>
        <div class="form-group">
          <label for="nombre">Nombre</label>
          <input
            type="text"
            name="nombre"
            id="nombre"
            class="form-control"
            [(ngModel)]="nombre"
            required
          />
        </div>
        <div class="form-group">
          <label for="nombreUsuario">Nombre de Usuario</label>
          <input
            type="text"
            name="nombreUsuario"
            id="nombreUsuario"
            class="form-control"
            [(ngModel)]="nombreUsuario"
            required
          />
        </div>
        <div class="form-group">
          <label for="password">Contraseña</label>
          <input
            type="password"
            name="password"
            id="password"
            class="form-control"
            [(ngModel)]="password"
            required
          />
        </div>
        <div class="form-group">
          <label for="email">Correo Electrónico</label>
          <input
            type="text"
            name="email"
            id="email"
            class="form-control"
            [(ngModel)]="email"
            required
          />
        </div>
        <div class="form-group">
          <button
            class="btn btn-outline-success btn-block"
            [disabled]="!f.valid"
          >
            <em class="fas fa-sign-in-alt"></em> Crear Cuenta
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
